import {StoreType} from '../../../types/sharedTypes';

export const allStoreMapsSelector = (state: StoreType) => {
  return state.storeMapReducer.storeMapsResult;
}
